






















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Room, BuildingsApi, Property, PropertiesApi } from 'performo-api';
import { mapGetters } from 'vuex';
import { handleApiError } from '@/ApiHelpers';

@Component({
  components: {},
  computed: mapGetters({
    api: 'buildingsApi',
    propertiesApi: 'propertiesApi'
  })
})
export default class Location2Picker extends Vue {
  @Prop({ required: false, default: 'location2-picker' })
  private id?: string;

  @Prop({ required: false, type: Boolean, default: false })
  private required?: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private hideAll?: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private hideLabel?: boolean;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: false, default: undefined })
  private buildingCode!: string;

  @Prop({ required: false, default: undefined })
  private floorCode!: string;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: false, type: String })
  private intendedValue?: string;

  get getValue() {
    return this.value;
  }

  private property: Property = {};
  private api!: BuildingsApi;
  private propertiesApi!: PropertiesApi;

  private rooms: Room[] = [];
  private loadingRooms = false;
  private hasMounted = false;

  private get location2Label() {
    return this.property?.location2Label;
  }

  @Watch('propertyId', { immediate: true })
  private async propertyIdChanged() {
    this.property = await this.propertiesApi.getProperty({
      propertyId: this.propertyId
    });
  }

  // make sure the component input is updated if intendedValue is used
  @Watch('intendedValue')
  private async intendedValueChanged() {
    this.$emit('input', this.intendedValue);
  }

  @Watch('buildingCode')
  @Watch('floorCode')
  private async loadRooms() {
    try {
      this.loadingRooms = true;
      if (this.hasMounted) {
        this.$emit('input', '');
      }
      const locationChoice = this.intendedValue;
      if (this.buildingCode) {
        await this.api
          .queryRooms({
            buildingCode: this.buildingCode,
            floorCode: this.floorCode,
            take: 1000,
            skip: 0
          })
          .then((rooms) => {
            if (rooms.data) {
              this.rooms = rooms.data;
            }
            if (
              locationChoice &&
              this.rooms.filter((c) => c.roomCode === locationChoice).length ===
                1
            ) {
              this.$emit('input', locationChoice);
            }
          })
          .catch(() => {
            /**? */
          });
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      this.loadingRooms = false;
    }
  }

  private async mounted() {
    if (this.buildingCode || this.floorCode) {
      this.loadRooms();
    }
    this.hasMounted = true;
  }

  public roomListContains(roomCode: string) {
    let found = false;
    this.rooms.forEach((element) => {
      if (element.roomCode === roomCode) {
        found = true;
      }
    });
    return found;
  }
}
